module.exports = __webpack_public_path__ + "img/sthree.e44f2fb5.png";